import { ChatResult } from "@memberjunction/ai";
import { RegisterClass } from "@memberjunction/global";


@RegisterClass(BaseMessageConverter, 'Base Message Converter')
export class BaseMessageConverter {
    constructor() {}

    public TransformGeneratedResponse(message: ChatResult): ChatResult {
        return message;
    }

    public TransformQualityCheckResponse(message: ChatResult): ChatResult {
        return message;
    }
}

export function LoadBaseMessageConverter(): void {

}